import AddEditTrust from "../Trust/AddEditTrust";
import { useOrganization } from "../../lib/context/OrganisationContext";
import Spin from "../../components/Spin";
import { useTrust } from "../../lib/context/TrustContext";
import { useUser } from "../../lib/context/UserContext";
import UnauthorisedAccess from "../../UnauthorisedAccess";

const EditTrust = () => {
  const { organizationData } = useOrganization();
  const { trustId } = useTrust();
  const { permission } = useUser();
  

  const hasWriteAccess = permission?.["trusts"]?.write;
  return hasWriteAccess ? (
    <div className="relative">
      {organizationData?.organizationId && trustId ? (
        <AddEditTrust
          edit={true}
          orgId={organizationData?.organizationId}
          trustID={trustId}
          tab={true}
        />
      ) : (
        <Spin />
      )}
    </div>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default EditTrust;
